/**
 * The connection diagram (the prototype's SECFLOW, in plain words since v39): your bank (where the
 * money sits) → you sign in on Flinks, never on our site → WealthyPlanet reads balances and
 * transactions only. The arrows say what travels along them; no money moves, in either direction.
 */
const STEPS: [string, string, string[], number][] = [
  ["Your bank", "#2B3C5C", ["where the money sits"], 0],
  ["You sign in", "#2E6FBF", ["on Flinks, the connector,", "never on our site"], 210],
  ["WealthyPlanet", "#8A5F0A", ["reads balances and", "transactions only"], 420],
];

export function SecFlow({ id }: { id?: string }) {
  return (
    <div id={id}>
      <svg
        viewBox="0 0 560 136"
        style={{ width: "100%", height: "auto" }}
        role="img"
        aria-label="Your bank, then a Flinks sign-in screen, then WealthyPlanet. Data travels one way along the chain. No money moves in either direction."
      >
        {STEPS.map(([label, color, lines, x]) => (
          <g key={label}>
            <rect
              x={x}
              y={22}
              width={140}
              height={58}
              rx={11}
              fill="#fff"
              stroke={color}
              strokeOpacity=".45"
            />
            <text
              x={x + 70}
              y={43}
              textAnchor="middle"
              fill={color}
              fontSize="12.5"
              fontFamily="Inter,sans-serif"
              fontWeight="600"
            >
              {label}
            </text>
            {lines.map((l, j) => (
              <text
                key={l}
                x={x + 70}
                y={58 + j * 13}
                textAnchor="middle"
                fill="#5A6B86"
                fontSize="10"
                fontFamily="Inter,sans-serif"
              >
                {l}
              </text>
            ))}
          </g>
        ))}
        {[145, 355].map((x) => (
          <g key={x}>
            <path d={`M${x} 51 L${x + 58} 51`} stroke="#8FBCF8" strokeWidth="1.4" />
            <path
              d={`M${x + 52} 46.5 L${x + 58} 51 L${x + 52} 55.5`}
              fill="none"
              stroke="#8FBCF8"
              strokeWidth="1.4"
            />
            <text
              x={x + 29}
              y={40}
              textAnchor="middle"
              fill="#8FBCF8"
              fontSize="9"
              fontFamily="Roboto Mono,monospace"
              letterSpacing="1.2"
            >
              DATA ONLY
            </text>
          </g>
        ))}
        <text
          x="280"
          y="108"
          textAnchor="middle"
          fill="#E8EEF9"
          fontSize="12.5"
          fontFamily="Inter,sans-serif"
          fontWeight="600"
        >
          No money moves, in either direction.
        </text>
        <text
          x="280"
          y="126"
          textAnchor="middle"
          fill="#9FB2D4"
          fontSize="11"
          fontFamily="Inter,sans-serif"
        >
          Abi can read your accounts. It has no way to move a dollar out of them.
        </text>
      </svg>
    </div>
  );
}
